import styled from "styled-components";
import Select from "react-select";
import { colorTheme, textTheme } from "../../theme";

// styling for the react-select library
export const customStyles = {
  control: (styles: any) => ({
    ...styles,
    height: 42,
    width: 184,
    paddingLeft: 5,
    borderColor: "rgba(195, 203, 205, 0.35)",
    boxShadow: "none",

    "&:hover": {
      cursor: "pointer",
    },
  }),
  indicatorSeparator: () => ({
    color: colorTheme.white,
  }),
  dropdownIndicator: () => ({
    color: colorTheme.grayDark,
    paddingRight: 15,
    paddingTop: 5,
  }),
  menu: (styles: any) => ({
    ...styles,
    backgroundColor: colorTheme.white,
    position: "absolute",
    top: 0,
    margin: 0,
    paddingBottom: 5,
    paddingTop: 10,
    borderRadius: 0,
  }),
  option: (styles: any) => ({
    ...styles,
    height: 42,
    width: 184,
    paddingLeft: 20,
    backgroundColor: colorTheme.white,
    color: colorTheme.black,

    "&:hover": {
      cursor: "pointer",
    },
  }),
};

export const Container = styled.div<{ alignRight: boolean }>`
  display: flex;
  justify-content: ${props => (props.alignRight ? "flex-end" : "")};
`;

export const TitleContainer = styled.div`
  ${textTheme.subtitle2}
  color: ${colorTheme.grayDark};
  position: relative;
`;

export const Title = styled.div`
  position: absolute;
  top: -25px;
`;

export const CustomContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
`;

export const DateSelector = styled(Select)`
  ${textTheme.body2};
  width: 184px;
  height: 42px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
  :focus {
    outline: 0 !important;
  }
`;

export const DatePickerContainer = styled.div`
  position: relative;
  float: left;
`;

export const Icon = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  margin-left: 18px;
`;

export const To = styled.span`
  margin: 0px 10px;
`;
